import { useManagement } from "./use-management";
import { get } from "lodash";
import { useSliceContent } from "./use-slice-content";
export var useSliceConnections = function (entity) {
  var _a;
  var _b = entity.connectedEntities,
    connectedEntities = _b === void 0 ? [] : _b,
    entityLayout = entity.entityLayout,
    label = entity.label;
  var variant = entityLayout === null || entityLayout === void 0 ? void 0 : entityLayout.internalName;
  var items = [];
  if (connectedEntities.length !== 0) {
    items = connectedEntities.flatMap(function (field) {
      return get(entity, field.internalName, []);
    });
  }
  var _c = useSliceContent(entity),
    hasIntro = _c.hasIntro,
    hasContent = _c.hasContent,
    hasOutro = _c.hasOutro;
  var canEdit = useManagement().canEdit;
  // console.log('SliceConnectionsDefinition', { label, entity, canEdit, hasIntro, hasContent, hasOutro, items, variant });
  return {
    entity: entity,
    canEdit: canEdit,
    hasContent: hasContent,
    hasIntro: hasIntro,
    hasOutro: hasOutro,
    label: label,
    items: items,
    variant: variant,
    shouldRender: !!((_a = entity === null || entity === void 0 ? void 0 : entity.entityFormFields) === null || _a === void 0 ? void 0 : _a.length) && (hasIntro || hasContent || hasOutro || !!items.length || canEdit)
  };
};